import { Environment } from './interface';

export const environment: Environment = {
  production: false,
  environment: 'Development',
  apiBase: 'https://riegermann-api.fsf.tools',
  oauth: {
    client_id: '1',
    client_secret: 'WKE5xFPCkdGO3PAGcRgBUEvt9YuXw1dDWgQoCraz',
  },
  pusher: {
    key: 'c1e557cde5e1d8b4f31d',
    cluster: 'eu',
  },
};
